import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardImg,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import photo from "../../../assets/kangaroo/Australian.png";
import MediaService from "../../../services/KangarooServices/MediaServices";
import {
  imageBaseApi,
  offshoreUrl,
  onshoreUrl,
} from "../../../utilis/imageHelper.js";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper.js";
import toast from "react-hot-toast";
import { RiFileCopyLine } from "react-icons/ri"; // Remix Icon via react-icons

const MediaDetail = ({ isOpen, toggle, selectedItem }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const authUser = getLoggedInUser();

  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles[0].includes("OffshoreAdmin");
  const [isOnshore, setIsOnshore] = useState(true);

  const fileUrl = `${imageBaseApi}${data?.url || ""}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(fileUrl);
      toast.success("Link copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy link");
    }
  };
  const fetchDetail = async () => {
    setLoading(true);
    try {
      const response = await MediaService.getDetail(selectedItem?.id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedItem?.id) {
      fetchDetail();
    }
  }, [selectedItem?.id]);

  const renderMediaPreview = () => {
    if (!data?.url) return null;

    const fileType = data.mimeType || "";
    if (fileType.includes("image")) {
      // Display image
      return (
        <img
          src={`${imageBaseApi}${data.url}`}
          alt="media"
          className="img-fluid h-100 object-fit-contain rounded"
        />
      );
    } else if (fileType === "application/pdf") {
      // Display PDF
      return (
        <iframe
          src={`${imageBaseApi}${data.url}`}
          title="PDF Preview"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else {
      // Fallback for other file types
      return <p className="text-center">Preview not available</p>;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>Attachment Detail</ModalHeader>

      <ModalBody>
        <Row className="gy-4">
          {/* Left: Media Preview */}
          <Col lg={7}>
            <Card className="shadow-sm border-0">
              <div
                className="d-flex justify-content-center align-items-center bg-light"
                style={{ height: "450px", borderRadius: "6px" }}
              >
                {renderMediaPreview()}
              </div>
            </Card>
          </Col>

          {/* Right: Details */}
          <Col lg={5}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <h5 className="mb-3 fw-semibold">File Information</h5>

                <div className="mb-3">
                  <label className="text-muted small mb-1">File Name</label>
                  <p className="fw-semibold">{data?.fileName}</p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1">Mime Type</label>
                  <p className="fw-semibold">{data?.mimeType}</p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1">Size</label>
                  <p className="fw-semibold">
                    {(data?.size / 1024 / 1024).toFixed(2)} MB
                  </p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1">Uploaded At</label>
                  <p className="fw-semibold">
                    {new Date(data?.uploadedAt).toLocaleString()}
                  </p>
                </div>

                <div className="">
                  {/* File URL */}
                  <div className="d-flex justify-content-between align-content-center align-items-center">
                    <label className="text-muted small mb-1">URL</label>

                    <Button
                      size="sm"
                      color="primary"
                      onClick={handleCopy}
                      className="d-flex align-items-center gap-1"
                      title="Copy"
                    >
                      <RiFileCopyLine size={16} />
                    </Button>
                  </div>

                  <p className="fw-semibold">{fileUrl}</p>

                  {/* Copy Button */}
                </div>
                <hr />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default MediaDetail;
